
import SkeletonSlider from './skeleton/Slider.vue';
import SwiperCore, { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/scss';
import 'swiper/scss/scrollbar';
import {mapGetters} from 'vuex';

SwiperCore.use([Scrollbar]);
export default {
    components: {
        SkeletonSlider,
        Swiper,
        SwiperSlide,
    },
    computed: {
        ...mapGetters('config', ['sliders']),
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch('config/loadSliders');
        this.loading = false;
    },
    data() {
        return {
            loading: false,
            sliderBreakpoints: {
                768: {
                    spaceBetween: 20
                },
                992: {
                    spaceBetween: 30
                }
            }
        };
    }
};
